import i18next, { type i18n } from "i18next";
import { DEFAULT_LANGUAGE } from "./context";

export interface LocaleNode {
  ns: string;
  data: string;
  language: string;
}

export interface LocaleEdges {
  edges: { node: LocaleNode }[];
}

const instances = new Map<string, i18n>();

/** Locale data is constant for the life of a build, so one instance per
    language serves every page instead of re-initialising on each render. */
export const createI18nInstance = (
  language: string,
  locales?: LocaleEdges
): i18n => {
  const cached = instances.get(language);
  if (cached) return cached;

  const resources: Record<string, Record<string, object>> = {};
  for (const { node } of locales?.edges ?? []) {
    resources[node.language] ??= {};
    resources[node.language][node.ns || "translation"] = JSON.parse(node.data);
  }

  const instance = i18next.createInstance();
  instance.init({
    resources,
    lng: language,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: "translation",
    keySeparator: ".",
    nsSeparator: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

  instances.set(language, instance);
  return instance;
};
